import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-col">
          <div className="footer-brand">
            <Logo size={36} />
            <h3>CadLap</h3>
          </div>
          <p>
            Precision land survey drafting for U.S. surveyors, engineers,
            and home builders — plus Estimation &amp; Quantity Takeoff for the
            U.S. &amp; UK. Accurate, reliable, and cost-effective.
          </p>
          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/company/cadlap"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i className="bi bi-linkedin"></i>
            </a>
            <a
              href="https://www.facebook.com/cadlap"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="bi bi-facebook"></i>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Land Survey Drafting Services</Link></li>
            <li><Link to="/estimation">Estimation &amp; Quantity Takeoff</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/why-choose-us">Why Choose Us?</Link></li>
            <li><Link to="/quote">Get a Quote</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/terms">Terms &amp; Conditions</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li>ALTA / NSPS Surveys</li>
            <li>Boundary Surveys</li>
            <li>Topographic Surveys</li>
            <li>Plot Plans &amp; Site Plans</li>
            <li>As-Built &amp; Final Surveys</li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Get In Touch</h4>
          <ul className="footer-contact">
            <li>
              <i className="bi bi-geo-alt-fill"></i>
              <span>124 Broadkill Rd #396, Milton, DE 19968, USA</span>
            </li>
            <li>
              <i className="bi bi-envelope-fill"></i>
              <a href="mailto:info@cadlap.com">info@cadlap.com</a>
            </li>
            <li>
              <i className="bi bi-telephone-fill"></i>
              <a href="tel:+10000000000">+1  (302) 487-0981</a>
            </li>
            <li>
              <i className="bi bi-clock-fill"></i>
              <span>24/7 Support &amp; Communication</span>
            </li>
            <li>
              <i className="bi bi-globe2"></i>
              <span>Serving the USA Market</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>Copyright © {year} All rights reserved by CadLap LLC.</p>
      </div>
    </footer>
  );
};

export default Footer;